import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export const BuzzlyLogo = ({ to = "/", light = false }) => (
  <Link to={to} className="inline-flex items-center gap-2 group" data-testid="buzzly-logo">
    <span className="w-8 h-8 sm:w-9 sm:h-9 shrink-0 rounded-xl bg-[#1877f2] grid place-items-center shadow-sm transition-transform duration-300 group-hover:rotate-12">
      <Zap className="w-5 h-5 text-white" strokeWidth={2.6} fill="white" />
    </span>
    <span className={`font-display text-xl sm:text-2xl font-extrabold tracking-tight ${light ? "text-white" : "text-[#050505]"}`}>
      Buzzly<span className={light ? "text-white/80" : "text-[#1877f2]"}>Me</span>
    </span>
  </Link>
);
